import { render, staticRenderFns } from "./OrderColumnBetaLinks.vue?vue&type=template&id=04813110&"
import script from "./OrderColumnBetaLinks.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnBetaLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports